<div class="page">

  <!-- Header -->
  <div class="checklist-header">
    <h1 class="header-title">Memory Vault</h1>
  </div>

  <!-- MAIN CONTENT BOX -->
  <div class="content-box">

    <!-- Search -->
    <div class="search-box">
      <svg class="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"/>
      </svg>
      <input
        type="text"
        [(ngModel)]="searchText"
        (input)="onSearch()"
        placeholder="Search memories..." />
    </div>

    <!-- Tabs -->
    <div class="tabs">
      <button
        *ngFor="let tab of tabs"
        [class.active]="activeTab === tab"
        (click)="setTab(tab)">
        {{ tab }}
      </button>
    </div>

    <!-- ALBUMS PAGE -->
    <div *ngIf="activeTab === 'Albums' && !isAlbumOpen && !loading" class="albums-page">
      <div class="album-card"
        *ngFor="let item of albums"
        [ngClass]="item.className"
        (click)="openAlbum(item); $event.stopPropagation()">
        <div class="album-cover-grid album-image-area">
          <div class="color-box">
            <img [src]="item.image" class="cover-main" />
          </div>
        </div>
        <div class="album-info">
          <div class="album-title-row">
            <h3>{{ item.title }}</h3>
            <span class="album-count-badge">{{ item.items?.length || 0 }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- INNER ALBUM VIEW -->
    <div *ngIf="isAlbumOpen" class="album-full-page">
      <div class="album-header">
        <button class="back-icon-btn" (click)="closeAlbum()">
          <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
        <div>
          <h2 class="album-title">{{ selectedAlbumName }}</h2>
          <p class="album-count">{{ selectedAlbumItems.length }} items</p>
        </div>
      </div>

      <div class="album-grid" *ngIf="selectedAlbumItems && selectedAlbumItems.length > 0">
        <div
          *ngFor="let item of selectedAlbumItems"
          class="card"
          (click)="
            item.tag === 'Voice'  && item.audio ? openAudio(item.audio) :
            item.tag === 'Links'  && item.link  ? openLink(item.link)   :
            item.tag === 'Videos' && item.video ? openVideo(item, $event) :
            openImage(item, $event)">

          <div class="image-wrapper" *ngIf="item.image && item.tag !== 'Videos'">
            <img [src]="item.image" [alt]="item.title" />
          </div>
          <div class="video-wrapper" *ngIf="item.video">
            <video muted playsinline><source [src]="item.video" type="video/mp4" /></video>
            <div class="play-icon">▶</div>
          </div>
          <div class="audio-box" *ngIf="item.audio">
            <img src="https://cdn-icons-png.flaticon.com/512/727/727245.png" class="audio-img" alt="audio" />
            <div class="play-audio-btn">▶ Play Audio</div>
          </div>
          <div class="audio-box" *ngIf="item.link">
            <div class="play-audio-btn">🔗 Open Link</div>
          </div>
          <div class="image-overlay"></div>
          <div class="card-body">
            <div class="content-wrap">
              <div class="text-content">
                <div class="tag-badge">
                  <ng-container *ngIf="item.tag === 'Photos'">● PHOTO</ng-container>
                  <ng-container *ngIf="item.tag === 'Videos'">● VIDEO</ng-container>
                  <ng-container *ngIf="item.tag === 'Voice'">● VOICE</ng-container>
                  <ng-container *ngIf="item.tag === 'Links'">● LINK</ng-container>
                  <ng-container *ngIf="item.tag === 'Stories'">● STORY</ng-container>
                </div>
                <h3>{{ item.title }}</h3>
                <small>{{ item.description || 'A beautiful memory captured forever.' }}</small>
              </div>
              <div class="icon-box">
                <span class="tag-icon">
                  <ng-container *ngIf="item.tag === 'Photos'"><i class="fa-regular fa-image"></i></ng-container>
                  <ng-container *ngIf="item.tag === 'Videos'"><i class="fa-solid fa-circle-play"></i></ng-container>
                  <ng-container *ngIf="item.tag === 'Voice'"><i class="fa-solid fa-microphone"></i></ng-container>
                  <ng-container *ngIf="item.tag === 'Links'"><i class="fa-solid fa-link"></i></ng-container>
                  <ng-container *ngIf="item.tag === 'Stories'"><i class="fa-solid fa-pen-to-square"></i></ng-container>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="no-data-found" *ngIf="selectedAlbumItems && selectedAlbumItems.length === 0">
        No data found in {{ selectedAlbumName }}
      </div>
    </div>

    <!-- NORMAL GRID -->
    <div class="grid" *ngIf="activeTab !== 'Albums' && !isAlbumOpen && !loading">
      <div
        *ngFor="let item of paginatedMemories"
        class="card"
        (click)="item.tag === 'Voice'  && item.audio ? openAudio(item.audio)
               : item.tag === 'Links'  && item.link  ? openLink(item.link)
               : item.tag === 'Videos' && item.video ? openVideo(item)
               : openImage(item)">

        <div class="image-wrapper" *ngIf="item.image && item.tag !== 'Videos'">
          <img [src]="item.image" [alt]="item.title" />
        </div>
        <div class="video-wrapper" *ngIf="item.video"
             (click)="$event.stopPropagation(); openVideo(item)">
          <video muted playsinline><source [src]="item.video" type="video/mp4" /></video>
          <div class="play-icon">▶</div>
        </div>
        <div class="audio-box" *ngIf="item.audio"
             (click)="$event.stopPropagation(); openAudio(item.audio)">
          <img src="https://cdn-icons-png.flaticon.com/512/727/727245.png" class="audio-img" alt="audio" />
          <div class="play-audio-btn">▶ Play Audio</div>
        </div>
        <div class="image-overlay"></div>

        <div class="card-body">
          <div class="content-wrap">
            <div class="text-content">
              <div class="tag-badge">
                <ng-container *ngIf="item.tag === 'Photos'">● PHOTO</ng-container>
                <ng-container *ngIf="item.tag === 'Videos'">● VIDEO</ng-container>
                <ng-container *ngIf="item.tag === 'Voice'">● VOICE</ng-container>
                <ng-container *ngIf="item.tag === 'Links'">● LINK</ng-container>
                <ng-container *ngIf="item.tag === 'Stories'">● STORY</ng-container>
              </div>
              <h3>{{ item.title }}</h3>
              <small>
                {{ item.description
                    ? (item.description.length > 50
                        ? (item.description | slice:0:50) + '...'
                        : item.description)
                    : 'A beautiful memory captured forever.' }}
              </small>
              <p>{{ item.date }}</p>
            </div>
            <div class="icon-box">
              <span class="tag-icon">
                <ng-container *ngIf="item.tag === 'Photos'"><i class="fa-regular fa-image"></i></ng-container>
                <ng-container *ngIf="item.tag === 'Videos'"><i class="fa-solid fa-circle-play"></i></ng-container>
                <ng-container *ngIf="item.tag === 'Voice'"><i class="fa-solid fa-microphone"></i></ng-container>
                <ng-container *ngIf="item.tag === 'Stories'"><i class="fa-solid fa-pen-to-square"></i></ng-container>
                <ng-container *ngIf="item.tag === 'Links'"><i class="fa-solid fa-link"></i></ng-container>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="contacts-pagination"
      *ngIf="activeTab !== 'Albums' && !isAlbumOpen && totalPages > 1">
      <button class="pagination-btn" [disabled]="currentPage === 1"
        (click)="changePage(currentPage - 1)">Previous</button>
      <div class="pagination-pages">
        <button *ngFor="let page of pages" class="pagination-page"
          [class.active]="currentPage === page"
          (click)="changePage(page)">{{ page }}</button>
      </div>
      <button class="pagination-btn" [disabled]="currentPage === totalPages"
        (click)="changePage(currentPage + 1)">Next</button>
    </div>

    <!-- Loading -->
    <div class="loading-state" *ngIf="loading">
      <div class="spinner"></div>
      <p>Loading memories...</p>
    </div>

  </div><!-- /content-box -->

  <!-- VIDEO SPLIT VIEW -->
  <div class="image-modal image-modal-split" *ngIf="selectedVideo && isMediaViewerOpen">
    <button class="modal-back-btn" (click)="closeVideo()">
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
      </svg>
      Back
    </button>
    <div class="modal-image-side">
      <video controls autoplay playsinline class="split-video-player">
        <source [src]="selectedVideo" type="video/mp4" />
      </video>
    </div>
    <div class="modal-detail-panel" *ngIf="selectedMemoryItem">
      <div class="detail-top-row"><div class="detail-tag">🎬 VIDEO</div></div>
      <h2 class="detail-title">{{ selectedMemoryItem.title }}</h2>
      <div class="detail-divider"></div>
      <p class="detail-description">{{ selectedMemoryItem.description || 'A beautiful memory captured forever.' }}</p>
      <div class="detail-meta">
        <div class="detail-meta-row">
          <span class="meta-label"><i class="fa-regular fa-calendar"></i> Date</span>
          <span class="meta-value">{{ selectedMemoryItem.date }}</span>
        </div>
        <div class="detail-meta-row" *ngIf="selectedMemoryItem.album">
          <span class="meta-label"><i class="fa-solid fa-photo-film"></i> Album</span>
          <span class="meta-value">{{ selectedMemoryItem.album }}</span>
        </div>
        <div class="detail-meta-row">
          <span class="meta-label"><i class="fa-solid fa-tag"></i> Type</span>
          <span class="meta-value">{{ selectedMemoryItem.tag }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- AUDIO POPUP -->
  <div class="audio-modal" *ngIf="selectedAudio">
    <button class="close-modal" (click)="closeAudio()">✕</button>
    <div class="audio-popup">
      <audio controls autoplay>
        <source [src]="selectedAudio" type="audio/mpeg" />
      </audio>
    </div>
  </div>

  <!-- IMAGE / LINK SPLIT VIEW -->
  <div class="image-modal image-modal-split"
    *ngIf="selectedImage && isMediaViewerOpen && selectedMemoryItem?.tag !== 'Stories'">

    <button class="modal-close-btn" (click)="closeImage()">
      <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
    <button class="modal-back-btn" (click)="closeImage()">
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
      </svg>
      Back
    </button>

    <div class="modal-image-side">
      <img *ngIf="selectedMemoryItem?.tag !== 'Links'" [src]="selectedImage" alt="full image" />
      <div *ngIf="selectedMemoryItem?.tag === 'Links'" class="modal-link-preview">
        <img *ngIf="selectedMemoryItem?.image" [src]="selectedMemoryItem?.image" alt="link preview" class="link-preview-img" />
        <div *ngIf="!selectedMemoryItem?.image" class="link-no-thumb">
          <i class="fa-solid fa-link" style="font-size:48px;color:#a5b4fc;"></i>
          <p>{{ selectedMemoryItem?.link }}</p>
        </div>
        <a [href]="selectedMemoryItem?.link" target="_blank" rel="noopener noreferrer" class="open-link-btn">
          <i class="fa-solid fa-arrow-up-right-from-square"></i> Open Link
        </a>
      </div>
    </div>

    <div class="modal-detail-panel" *ngIf="selectedMemoryItem">
      <div class="detail-top-row">
        <div class="detail-tag">
          <ng-container *ngIf="selectedMemoryItem.tag === 'Photos'">📷 PHOTO</ng-container>
          <ng-container *ngIf="selectedMemoryItem.tag === 'Links'">🔗 LINK</ng-container>
          <ng-container *ngIf="selectedMemoryItem.tag === 'Voice'">🎙️ VOICE</ng-container>
          <ng-container *ngIf="selectedMemoryItem.tag === 'Videos'">🎬 VIDEO</ng-container>
        </div>
      </div>
      <h2 class="detail-title">{{ selectedMemoryItem.title }}</h2>
      <div class="detail-divider"></div>
      <p class="detail-description">{{ selectedMemoryItem.description || 'A beautiful memory captured forever.' }}</p>
      <div *ngIf="selectedMemoryItem.tag === 'Links' && selectedMemoryItem.link" class="detail-url-box">
        <i class="fa-solid fa-link"></i>
        <a [href]="selectedMemoryItem.link" target="_blank" rel="noopener noreferrer" class="detail-url-text">
          {{ selectedMemoryItem.link }}
        </a>
      </div>
      <div class="detail-meta">
        <div class="detail-meta-row">
          <span class="meta-label"><i class="fa-regular fa-calendar"></i> Date</span>
          <span class="meta-value">{{ selectedMemoryItem.date }}</span>
        </div>
        <div class="detail-meta-row" *ngIf="selectedMemoryItem.album">
          <span class="meta-label"><i class="fa-solid fa-photo-film"></i> Album</span>
          <span class="meta-value">{{ selectedMemoryItem.album }}</span>
        </div>
        <div class="detail-meta-row">
          <span class="meta-label"><i class="fa-solid fa-tag"></i> Type</span>
          <span class="meta-value type-badge">{{ selectedMemoryItem.tag }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ===================== STORY DIALOG ===================== -->
  <div
    class="story-overlay"
    *ngIf="isStoryDialogOpen && selectedMemoryItem?.tag === 'Stories'"
    (click)="closeStoryDialog()">

    <!-- Wrapper: provides anchor point for outside close button -->
    <div class="story-dialog-wrapper" (click)="$event.stopPropagation()">

      <!-- Close button: OUTSIDE the card, pinned to wrapper's top-right -->
      <button class="story-close-btn" (click)="closeStoryDialog()" aria-label="Close story">
        <svg width="17" height="17" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>

      <!-- Main story dialog card -->
      <div class="story-dialog">

      <!-- Ambient glow blobs -->
      <div class="story-blob story-blob-tr"></div>
      <div class="story-blob story-blob-bl"></div>
      <div class="story-blob story-blob-mc"></div>

      <!-- Inner content -->
      <div class="story-inner">

        <!-- Eyebrow label -->
        <div class="story-eyebrow">
          <span class="story-eyebrow-line"></span>
          <span class="story-eyebrow-text">S T O R Y</span>
          <span class="story-eyebrow-line"></span>
        </div>

        <!-- Title -->
        <h2 class="story-dialog-title">{{ selectedMemoryItem?.title }}</h2>

        <!-- Ornament divider -->
        <div class="story-ornament">
          <span class="orn-wing"></span>
          <svg class="orn-glyph" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 1 L9.5 6.5 L15 8 L9.5 9.5 L8 15 L6.5 9.5 L1 8 L6.5 6.5 Z" opacity="0.65"/>
          </svg>
          <span class="orn-wing"></span>
        </div>

        <!-- Body text -->
        <div class="story-body-scroll">
          <p class="story-body-text">
            {{ selectedMemoryItem?.description || 'A beautiful story captured forever.' }}
          </p>
        </div>

        <!-- Footer -->
        <div class="story-footer">
          <span class="story-footer-item" *ngIf="selectedMemoryItem?.date">
            <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            {{ selectedMemoryItem?.date }}
          </span>
          <span class="story-footer-dot"
            *ngIf="selectedMemoryItem?.date && selectedMemoryItem?.album">◆</span>
          <span class="story-footer-item" *ngIf="selectedMemoryItem?.album">
            <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <rect x="3" y="3" width="18" height="18" rx="2"/>
              <circle cx="8.5" cy="8.5" r="1.5"/>
              <polyline points="21 15 16 10 5 21"/>
            </svg>
            {{ selectedMemoryItem?.album }}
          </span>
        </div>

      </div><!-- /story-inner -->
      </div><!-- /story-dialog -->
    </div><!-- /story-dialog-wrapper -->
  </div><!-- /story-overlay -->

</div><!-- /page -->